/* eslint-disable import/no-unresolved */
import BarcodeReader from '@/components/BarcodeReader';
import { ProvidersProps } from '../providers.types';

const BarcodeReaderProvider: React.FC<ProvidersProps> = ({ children }) => (
  <BarcodeReader>{children}</BarcodeReader>
);
export default BarcodeReaderProvider;
